import  { useState } from 'react';
import toast from 'react-hot-toast';
import styles from './ModalForm.module.css';

const ModalForm = ({ isOpen, closeModal }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    organization: '',
    message: '',
  });
  
  const [submissionStatus, setSubmissionStatus] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) return;

    setIsSubmitting(true);
    setSubmissionStatus('');

        toast.success('Message sent successfully! We will get back to you soon.');
        setSubmissionStatus('Message sent successfully!');

        // Reset form
        setFormData({
          name: '',
          email: '',
          organization: '',
          message: '',
        });
        

        // Close modal after a delay
        setTimeout(() => {
          setIsSubmitting(false);
          setSubmissionStatus('');
          closeModal();
        }, 2000);
      
    
  };

  return (
    <div className={`${styles.modal} ${isOpen ? styles.open : ''}`} onClick={closeModal}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <h2 className={styles.modalTitle}>Get Free Flight Quotes & Travel Consultation</h2>
        
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Name"
            value={formData.name}
            onChange={handleChange}
            required
            className={styles.formInput}
          />
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            required
            className={styles.formInput}
          />
          <input
            type="text"
            name="organization"
            placeholder="Preferred Destination"
            value={formData.organization}
            onChange={handleChange}
            required
            className={styles.formInput}
          />
          <textarea
            name="message"
            placeholder="Tell us about your travel preferences, dates, and group size..."
            value={formData.message}
            onChange={handleChange}
            required
            className={styles.formTextarea}
          ></textarea>
          {submissionStatus && <p className={styles.successMessage}>{submissionStatus}</p>}
          <button
            type="submit"
            className={styles.submitButton}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Sending...' : 'Send Message'}
          </button>
        </form>
        <button className={styles.closeBtn} onClick={closeModal}>
          Close
        </button>
      </div>
    </div>
  );
};

export default ModalForm;
